import { render, staticRenderFns } from "./CustomCertificateComponent.vue?vue&type=template&id=4114b444"
import script from "./CustomCertificateComponent.vue?vue&type=script&lang=js"
export * from "./CustomCertificateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports